import React, { ReactNode } from 'react';
import { Text } from '@wix/design-system';
import s from './Tag.module.scss';
import { Theme } from '../../types';
import cs from 'classnames';

export interface ITag {
  text: string;
  icon?: ReactNode;
  iconPosition?: 'start' | 'end';
  onClick: () => void;
  disabled?: boolean;
}

interface TagProps extends ITag {
  theme: Theme;
}

export const Tag = ({
  text,
  icon,
  iconPosition = 'start',
  theme,
  disabled,
  onClick,
}: TagProps) => {
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <div
      className={cs(s.tag, {
        [s.tagIconEnd]: iconPosition === 'end',
        [s.tagDark]: theme === 'dark',
        [s.tagDisabled]: disabled,
      })}
      onClick={handleClick}
    >
      {icon}
      <Text size="tiny" light={theme === 'dark'}>
        {text}
      </Text>
    </div>
  );
};
